// Tax regime rules shared by the client form, the invoice editor, the invoice
// pipeline modal and the PDF preview. One copy, so a client's default regime,
// the GST % it implies and the letterhead it prints on cannot drift apart.

export const TAX_REGIME_OPTIONS = [
  { value: 'IN_inter_state', label: 'India — Inter-state (IGST 18%)', taxPercent: 18 },
  { value: 'IN_intra_state', label: 'India — Intra-state (CGST 9% + SGST 9%)', taxPercent: 18 },
  { value: 'NL',             label: 'Netherlands (VAT 21%)',          taxPercent: 21 },
  { value: 'Other',          label: 'Other (custom %)',               taxPercent: null },
];

const KNOWN_REGIMES = new Set(TAX_REGIME_OPTIONS.map(o => o.value));

// The client form used to offer values the invoice form never knew
// ('EU_VAT', 'None'). Read those as what they meant; anything else unknown is
// treated as unset so the caller falls back to its own default.
const LEGACY_REGIMES = { EU_VAT: 'NL' };

export const normalizeTaxRegime = (regime) => {
  if (!regime) return null;
  if (KNOWN_REGIMES.has(regime)) return regime;
  return LEGACY_REGIMES[regime] || null;
};

export const getTaxPercentForRegime = (regime, customPct) => {
  if (regime === 'Other') return Number(customPct) || 0;
  const opt = TAX_REGIME_OPTIONS.find(o => o.value === regime);
  return opt?.taxPercent ?? 18;
};

// Office an invoice belongs to by its tax regime: GST is billed from Mumbai,
// Dutch VAT from Rotterdam. 'Other' says nothing about the office, so it
// returns null and the caller keeps the office it already has.
export const officeForTaxRegime = (regime) => {
  const r = normalizeTaxRegime(regime);
  if (r === 'IN_inter_state' || r === 'IN_intra_state') return 'IN';
  if (r === 'NL') return 'NL';
  return null;
};

// Letterhead for the PDF: the tax regime decides, the invoice's stored office
// decides when the regime does not ('Other' or unset).
export const letterheadForInvoice = (inv) => {
  const office = officeForTaxRegime(inv?.taxRegime) || inv?.officeLocation || 'NL';
  return office === 'IN' ? 'mumbai' : 'rotterdam';
};
